<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-15 16:31:55
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-15 16:36:01
 * @name: 主页-主要部分
 * @Description: 主页-主要部分
 * @FilePath: \preSaleNafterSaleInside\project\src\components\index\index-main.vue
 * @Author: desktop
-->
<template>
  <div class="indexMain">
    <div class="container">
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>
<script>
export default {
  name: "indexMain",
};
</script>
<style lang="scss" scoped>
.indexMain {
  width: 100%;
  flex: 1;
  overflow-y: auto;
  .container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
}
</style>